
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { DatePicker } from 'antd-mobile'

export const labelRenderer = (type: string, data: number) => {
    switch (type) {
        case 'year':
            return data + '年'
        case 'month':
            return data + '月'
        case 'day':
            return data + '日'
        case 'hour':
            return data + '时'
        case 'minute':
            return data + '分'
        case 'second':
            return data + '秒'
        default:
            return data
    }
}

const AiDatePicker:any = {}

AiDatePicker.prompt = (options) => {
    return new Promise((resolve, reject) => {
        const _div = document.getElementById('ai-date-picker-id')
        if(_div) {
            // AiDatePicker.destroy()
        }
        let div = document.createElement('div')
        div.id = 'ai-date-picker-id'
        document.body.appendChild(div);

        const AiDatePickerHook = props => {
            const [visible, setVisible] = useState(false)
            useEffect(() => {
                setVisible(true)
            },[])
            const onConfirm = value => {
                if( options?.onConfirm ) {
                    options.onConfirm(value)
                }
                resolve(value)
                setVisible(false)
                AiDatePicker.destroy()
            }
            const onCancel = () => {
                if( options?.onCancel ) {
                    options.onCancel()
                }
                setVisible(false)
                AiDatePicker.destroy()
                resolve(null)
            }
            return  <DatePicker {...options} visible={visible} onCancel={onCancel} onConfirm={onConfirm} />
        }
        ReactDOM.render(<AiDatePickerHook />, div)
    })
}

AiDatePicker.destroy = () => {
    const div = document.getElementById('ai-date-picker-id')
    if( div ) {
        ReactDOM.render(null, div)
        document.body.removeChild(div)
    }
}

export default AiDatePicker